<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">&#9776;
    </button>
    <b-link class="navbar-brand" :class="tenant" to="#"></b-link>
    <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarToggle">&#9776;
    </button>
    <!--b-nav is-nav-bar class="ml-auto">
      <span style="margin: 0 20px">User ID: {{ username }}</span>
    </b-nav-->
  </header>
</template>
<script>
  export default {
    name: 'header',
    data () {
      return {
        tenant: ''
      }
    },
    methods: {
      updateTenant () {
        this.tenant = this.$store.state.tenant
        // console.log(this.tenant)
      },
      sidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-hidden')
      },
      sidebarMinimize (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-minimized')
      },
      mobileSidebarToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('sidebar-mobile-show')
      },
      asideToggle (e) {
        e.preventDefault()
        document.body.classList.toggle('aside-menu-hidden')
      }
    },
    computed: {
      name () {
        return this.$route.name
      },
      list () {
        return this.$route.matched
      }
    },
    created () {
      this.updateTenant()
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue?7bc45abc